import {
  PremiumPubReviewHeader,
  PremiumPubReviewList,
  PremiumPubReviewWrapper,
} from "./style";
import { useEffect, useState } from "react";
import ImageViewer from "../../../../../components/ImageViewer";
import useUserInfo from "../../../../../hooks/useUserInfo";
import { usePubContext } from "../../hooks/pub-context";
import { ReviewDataResponse } from "../../../../../api/types";
import PremiumPubReviewItem from "./components/review-item";

const PremiumPubReview = () => {
  const { user } = useUserInfo();
  const { data, setShowWrite } = usePubContext();
  const [visibleCount, setVisibleCount] = useState(5);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(-1);
  const [imageList, setImageList] = useState<string[]>([]);
  const [list, setList] = useState<ReviewDataResponse[]>([]);

  useEffect(() => {
    if (!data) return;
    setList(data.reviewData.slice(0, visibleCount));
  }, [data, visibleCount]);

  const showWriteButton = () => {
    if (!user) return false;
    if (data?.reviewData.length === 0) return true;
    return data?.reviewData.some((item) => item.userName !== user.nickname);
  };

  return (
    <PremiumPubReviewWrapper>
      {selectedImageIndex !== -1 && (
        <ImageViewer
          images={imageList || []}
          defaultIndex={selectedImageIndex}
          onClose={() => setSelectedImageIndex(-1)}
        />
      )}
      <PremiumPubReviewHeader>
        <div className="title">리뷰</div>
        {showWriteButton() && (
          <div className="write" onClick={() => setShowWrite(true)}>
            리뷰 작성
          </div>
        )}
      </PremiumPubReviewHeader>
      <PremiumPubReviewList>
        {list.length === 0 ? (
          <div className="no-data">등록된 리뷰가 없습니다. </div>
        ) : (
          list.map((item, index) => (
            <PremiumPubReviewItem
              key={index}
              item={item}
              setImageList={setImageList}
              setSelectedImageIndex={setSelectedImageIndex}
            />
          ))
        )}
        {visibleCount < (data?.reviewCount || 0) && (
          <div
            className="more"
            onClick={() => setVisibleCount((prevCount) => prevCount + 5)}
          >
            더보기
          </div>
        )}
      </PremiumPubReviewList>
    </PremiumPubReviewWrapper>
  );
};

export default PremiumPubReview;
